var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 30,
    height: 30,
    rx: 10,
    fill: "#5B7FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 12.75H20.625M15 21.1875C18.4172 21.1875 21.1875 18.4172 21.1875 15C21.1875 11.5828 18.4172 8.8125 15 8.8125C11.5828 8.8125 8.8125 11.5828 8.8125 15C8.8125 18.4172 11.5828 21.1875 15 21.1875ZM15 21.1875C16.6875 21.1875 17.25 18.375 17.25 15C17.25 11.625 16.6875 8.8125 15 8.8125C13.3125 8.8125 12.75 11.625 12.75 15C12.75 18.375 13.3125 21.1875 15 21.1875ZM9.375 17.25H20.625H9.375Z",
    stroke: "#5B7FFF",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/Language.d7aa91d51d46832fd4c2d9b62d77289f.svg";
export { ForwardRef as ReactComponent };